<template>
    <div>
      <!-- Dynamically render the form component based on the note type -->
      <component v-if="userFetched && formComponent" :is="formComponent" :clientDetails="clientDetails"
      :username="username" :user_id="user_id" :user_groups="user_groups"></component>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import Swal from 'sweetalert2';
  import EditClientProfile from './EditClientProfile.vue'; // Example of a form component for a specific type
  // Import other form components
  
  export default {
    components: {
      EditClientProfile,
      // Register other form components here
    },
    data() {
      return {
        permissions: [],
        clientDetails: "",
        username : '',
        user_id : null,
        userFetched: false,
        user_groups: []
      };
    },
    computed: {
      canViewClientDetail() {
        return this.hasAnyPerm(['accounting.view_client_detail'])
      },
      formComponent() {
        return 'EditClientProfile';
      },
    },
    async created() {
      this.loadPermissions();
      if (!this.canViewClientDetail) {
        Swal.fire('Sin acceso', 'No tienes permisos para ver el cliente.', 'warning');
        this.$router.push({ path: '/main-panel' });
        return;
      }
      await this.fetchProfileDetails();
      await this.fetchCurrentUser();
    },
    methods: {
      loadPermissions() {
        try {
          this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || [];
        } catch (error) {
          this.permissions = [];
        }
      },
      hasPerm(perm) {
        if (!perm) return false;
        if (this.permissions.includes(perm)) return true;
        return this.permissions.includes(`access_control.${perm}`);
      },
      hasAnyPerm(perms) {
        if (!Array.isArray(perms) || perms.length === 0) return false;
        return perms.some((perm) => this.hasPerm(perm));
      },
      async fetchProfileDetails() {
        const client_id = this.$route.params.client_id;
        console.log(client_id)
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/clients/` + client_id + "/");
          this.clientDetails = response.data;
        } catch (error) {
          console.error("Failed to fetch employee details:", error);
          // Handle error (e.g., show user feedback)
        }
      },

      fetchCurrentUser() {
      /** Fetches the current user data, used to fill in who is making an assignation */
      const apiDirectory = process.env.API_DIRECTORY;
      axios.get(`${apiDirectory}/current-user/`, {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('authToken')
        }
      })
        .then(response => {
          //this.username = response.data.username;
          //this.firstName = response.data.first_name;
          //this.lastName = response.data.last_name;
          this.user_groups = response.data.groups;
          this.user_id = response.data.id;
          this.userFetched = true; // Set userFetched to true once user data is fetched
        })
        .catch(error => {
          console.error('There was an error fetching the user data:', error);
        });
    },
    }
  };
  </script>